import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'bootstrap-datetime-picker/css/bootstrap-datetimepicker.css';
